import { useCallback, useEffect, useState } from "react"
import { useAppSelector } from "./redux/hooks"
import { getStore, setStore } from "utils/store"
import { ChaingeTokenChain } from "types/baseType"

const trendList = ['CHNG', 'USDT', 'USDC', 'BTC', 'ETH', 'FSN', 'BNB', 'MATIC']
const defaultList = ['CHNG', 'USDT', 'USDC', 'BTC', 'ETH', 'FSN', 'BNB', 'MATIC']

const useDefTrendToken = () => {
    const { tokens } = useAppSelector((state) => state.app)
    const [trendTokens, setTrendTokens] = useState<ChaingeTokenChain[]>([])
    const [recentTokens, setRecentTokens] = useState<ChaingeTokenChain[]>([])

    const changeRecentList = useCallback((symbolName: string) => {
        if(!tokens) return
        let recentSearchList = getStore('chainge.recentToken') || []
        if(recentSearchList.length < 15) {
            if(recentSearchList.includes(symbolName)) {
                return
            }
            recentSearchList.unshift(symbolName)
        }
        setStore('chainge.recentToken', recentSearchList)
        const curToken = tokens.find(item => item.symbol === symbolName)
        if(curToken) {
            const tempRecentTokens = [...recentTokens]
            tempRecentTokens.unshift(curToken)
            setRecentTokens(tempRecentTokens)
        }

    }, [recentTokens, tokens])

    useEffect(() => {
        if(tokens.length) {
            let recentSearchList = getStore('chainge.recentToken')
            if(!recentSearchList || (recentSearchList && recentSearchList.length === 0)) {
             recentSearchList = defaultList
            }
            const tempTrendList: ChaingeTokenChain[]  = []
            const tempRecent: ChaingeTokenChain[] = []
            tokens.forEach(item => {
                if(trendList.includes(item.symbol)) {
                    tempTrendList.push(item)
                }
                if(recentSearchList.includes(item.symbol)) {
                    tempRecent.push(item)
                }
            })
            setTrendTokens(tempTrendList)
            setRecentTokens(tempRecent)
        }
    }, [tokens])
    
    return { trendTokens, recentTokens, changeRecentList}
}

export default useDefTrendToken